import React from 'react';
import { useDrawers } from '../../contexts/DrawerContext';
import { Button } from '../ui/Button';
const STEPS = [{
  num: '01',
  title: 'Send the details',
  desc: 'Tell us whether you are buying, selling or reviewing a contract. Upload documents where relevant.'
}, {
  num: '02',
  title: 'Confirm scope and timing',
  desc: 'The team reviews the matter, identifies deadlines and explains the proposed scope and fee.'
}, {
  num: '03',
  title: 'Review and advice',
  desc: 'Relevant documents, conditions and transaction risks are considered and explained.'
}, {
  num: '04',
  title: 'Transaction management',
  desc: 'The team coordinates documents, parties, dates and settlement requirements.'
}, {
  num: '05',
  title: 'Settlement and confirmation',
  desc: 'You are kept informed as the matter reaches settlement and completion.'
}];
export function Process() {
  const {
    openUpload
  } = useDrawers();
  return <section className="py-20 md:py-28 px-5 md:px-6 bg-cream" data-id="element-314">
      <div className="max-w-7xl mx-auto" data-id="element-315">
        <div className="max-w-2xl mb-14" data-id="element-316">
          <p className="text-accent font-script text-2xl mb-1" data-id="element-317">no surprises</p>
          <h2 className="text-3xl md:text-[2.6rem] leading-tight text-ink" data-id="element-318">
            A clear process from first contact to settlement.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5" data-id="element-319">
          {STEPS.map((step, i) => <div key={step.num} className="relative rounded-3xl bg-surface border border-border p-6 shadow-card flex flex-col" data-id="element-320">
              <span className="font-serif text-3xl text-accent/30" data-id="element-321">
                {step.num}
              </span>
              <div className="my-4 h-px w-10 bg-accent/40" data-id="element-322" />
              <h3 className="font-serif text-xl text-ink mb-2" data-id="element-323">{step.title}</h3>
              <p className="text-sm text-muted-ink leading-relaxed" data-id="element-324">
                {step.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-4 rounded-3xl bg-surface border border-border p-6 md:p-8" data-id="element-325">
          <p className="text-ink text-lg flex-1" data-id="element-326">
            Ready to begin? The fastest first step is to send the contract.
          </p>
          <Button onClick={openUpload} variant="accent" size="lg" data-id="element-327">
            Upload a contract
          </Button>
        </div>
      </div>
    </section>;
}